import React, {useEffect, useState} from 'react';
import {addPrefix} from '../../../utils/UriUtil';
import {jsonResponseHandler, revenueResponseHandler} from '../../../utils/FetchHelper';
import {useDispatch} from 'react-redux';
import BoxPreview from './BoxPreview';
import AdEditDialog from './AdEditDialog';
import Preview from '../../../containers/revenue/Preview';
import {isTrue} from "../revenueUtils";
import {cloneDeep, isEqual} from 'lodash';
import DefaultBoxPreview from "./DefaultBoxPreview";
import DefaultAdSettingBox from "./DefaultAdSettingBox";
import RevenueDialog from "../RevenueDialog";
import TSubmitButtonForm from "../../common/TSubmitButtonForm";
import * as SaveStatusLabel from "../../../constants/SaveStatusLabel";
import * as SaveStatus from "../../../constants/SaveStatus";

const AdSetting = () => {
  const dispatch = useDispatch();
  const [activateAvailable, setActivateAvailable] = useState(null);
  const [adSetting, setAdSetting] = useState(null);
  const [changedAdSetting, setChangedAdSetting] = useState(null);
  const [activateInfo, setActivateInfo] = useState(null);
  const [editingPosition, setEditingPosition] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [previewSettings, setPreviewSettings] = useState(null);
  const [saveStatus, setSaveStatus] = useState(SaveStatus.READY);
  const [error, setError] = useState(false);

  const positionList = [
    'automatic', 'content_upper', 'content_lower', 'sidebar', 'list_upper', 'list_lower',
  ];

  const positionToName = {
    automatic: '전체 자동광고',
    content_upper: '본문 상단',
    content_lower: '본문 하단',
    sidebar: '사이드바',
    list_upper: '목록 상단',
    list_lower: '목록 하단',
  };

  /**
   * 미리보기 노출 상태 변경
   */
  const showPreviewHandler = () => {
    makePreviewSettings();
    setShowPreview(!showPreview);
  };

  const makePreviewSettings = () => {
    if (!changedAdSetting)
      return;
    const copied = cloneDeep(changedAdSetting);
    let settings = {};
    Object.keys(copied).forEach((key) => {
      const item = copied[key];
      if (isTrue(item.activate)) {
        delete item.optionList;
        settings[key] = item;
      }

    });

    setPreviewSettings(settings);
  };

  const getPcType = (position) => {
    let ret;
    if (changedAdSetting) {
      if (position === 'automatic' || position === 'sidebar') {
        ret = changedAdSetting[position].activate === 1 ? changedAdSetting[position].type : '사용 안함';
      } else {
        ret = changedAdSetting[`pc_${position}`].activate === 1 ? changedAdSetting[`pc_${position}`].type : '사용 안함';
      }
      ret = ret === 'RESPONSIVE' ? '반응형' : ret;
      return ret.split('x').join(' x ');
    }
  };
  const getMobileType = (position) => {
    let ret;
    if (changedAdSetting) {
      if (position === 'automatic') {
        ret = changedAdSetting['automatic'].activate === 1 ? changedAdSetting['automatic'].type : '사용 안함';
      } else if (position === 'sidebar') {
        ret = '사용 안함'
      } else {
        ret = changedAdSetting[`mo_${position}`].activate === 1 ? changedAdSetting[`mo_${position}`].type : '사용 안함';
      }
      ret = ret === 'RESPONSIVE' ? '반응형' : ret;
      return ret.split('x').join(' x ');
    }
  };

  const handleClickEdit = (position) => {
    if (position === 'sidebar' || position === 'automatic') {
      if (changedAdSetting[position].activate === 0) {
        alert('활성화 후 수정하세요');
        return;
      }
    } else {
      if (changedAdSetting[`pc_${position}`].activate === 0 && changedAdSetting[`mo_${position}`].activate === 0) {
        alert('활성화 후 수정하세요');
        return;
      }
    }
    setEditingPosition(position);
  };
  const handleClickPopupCancel = () => {
    setEditingPosition(null);
  };
  const handleClickPopupConfirm = (changed, e) => {
    e.preventDefault();
    const copied = cloneDeep(changed);
    if (copied['automatic'].option.length === 0) {
      copied['automatic'].activate = 0;
    }

    if (isEqual(adSetting, copied)) {
      setSaveStatus(SaveStatus.READY);
    } else {
      setSaveStatus(SaveStatus.CAN_SUBMIT);
    }

    setChangedAdSetting(copied);
    setEditingPosition(null);
  };
  const setActive = (position, bool) => {
    const copied = cloneDeep(changedAdSetting);
    if (position === 'sidebar') {
      copied[position].activate = bool ? 1 : 0;
    } else if (position === 'automatic') {
      copied[position].activate = bool ? 1 : 0;
      copied[position].option = bool ? ['LIST', 'HOME', 'VIEW'] : [];
    } else {
      copied[`pc_${position}`].activate = bool ? 1 : 0;
      copied[`mo_${position}`].activate = bool ? 1 : 0;
    }

    if (isEqual(adSetting, copied)) {
      setSaveStatus(SaveStatus.READY);
    } else {
      setSaveStatus(SaveStatus.CAN_SUBMIT);
    }

    setChangedAdSetting(copied);
  };

  const handleClickToggle = (position, bool) => {
    if (!bool) {
      setActive(position, false);
    } else {
      if (position === 'list_upper') {
        if (!activateAvailable[`pc_${position}`] || !activateAvailable[`mo_${position}`]) {
          setActivateInfo({
            title: '목록 상단 광고',
            content: '스킨에 목록 상단 치환자가 없어 광고를 설정할 수 없습니다.',
            required: '[##_revenue_list_upper_##]',
            cancel: false,
            confirm: () => setActivateInfo(null)
          });
        } else {
          setActive(position, true);
        }
      } else if (position === 'list_lower') {
        if (!activateAvailable[`pc_${position}`] || !activateAvailable[`mo_${position}`]) {
          setActivateInfo({
            title: '목록 하단 광고',
            content: '스킨에 목록 하단 치환자가 없어 광고를 설정할 수 없습니다.',
            required: '[##_revenue_list_lower_##]',
            cancel: false,
            confirm: () => setActivateInfo(null)
          });
        } else {
          setActive(position, true);
        }
      } else if (position === 'sidebar') {
        if (!activateAvailable['sidebar']) {
          setActivateInfo({
            title: '사이드바 광고',
            content: '적용된 스킨에 사이드바가 없어 광고를 설정할 수 없습니다. 스킨을 확인해 주세요',
            required: '',
            cancel: false,
            confirm: () => setActivateInfo(null)
          });
        } else {
          setActivateInfo({
            title: '사이드바 광고',
            content: `사이드바 광고 적용 후 ‘꾸미기 > 사이드바’에서 세부 위치를 설정할 수 있습니다.`,
            required: '',
            cancel: true,
            confirm: () => {setActive(position, true);setActivateInfo(null)}
          });
        }
      } else {
        setActive(position, true);
      }
    }
  };

  const findDifference = () => {
    const compare = (obj1, obj2) => {
      const item = {};
      let flag = false;
      item.id = obj2.id;
      if (obj1.type !== obj2.type) {
        item.type = obj2.type;
        flag = true;
      }
      if (obj1.activate !== obj2.activate) {
        item.activate = obj2.activate;
        flag = true;
      }
      if (!isEqual(obj1.option, obj2.option)) {
        item.option = obj2.option;
        flag = true;
      }
      if (flag) {
        return item;
      } else {
        return null;
      }
    };
    const ret = {
      items: [],
    };
    for (let key of Object.keys(adSetting)) {
      const item = compare(adSetting[key], changedAdSetting[key]);
      if (item) {
        ret.items.push(item);
      }
    }
    return ret;
  };

  const checkActivated = (position) => {
    if (changedAdSetting) {
      if (position === 'content_middle') {
        return false;
      } else if (position === 'sidebar' || position === 'automatic') {
        return changedAdSetting[position].activate === 1
      } else {
        return changedAdSetting[`pc_${position}`].activate === 1 || changedAdSetting[`mo_${position}`].activate === 1
      }
    } else {
      return false;
    }
  };

  const save = () => {
    setSaveStatus(SaveStatus.DOING);
    const diff = findDifference();
    fetch(addPrefix('/manage/revenue/adunits/adsense.json'),
      {
        method: 'put',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(diff),
      })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then(() => {
        fetchAdSetting();
        setSaveStatus(SaveStatus.DONE);
      })
      .catch(() => {
        setSaveStatus(SaveStatus.READY);
        alert('저장 실패');
      });
  };

  const fetchAdSetting = () => {
    setError(false);
    fetch(addPrefix('/manage/revenue/adunits/adsense.json'), {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        if (data && !Array.isArray(data.data)) {
          setActivateAvailable(cloneDeep(data.data.activateInfo));
          setAdSetting(cloneDeep(data.data.list));
          setChangedAdSetting(cloneDeep(data.data.list));
        }
      })
      .catch(e => {
        console.error(e);
        setError(true);
      });
  };

  useEffect(() => {
    fetchAdSetting();
  }, []);

  return (
    <div className="revenue_position google_preview">
      {changedAdSetting &&
      <>
        <BoxPreview
          checkActivated={checkActivated}
          handleClickToggle={handleClickToggle}
        />
        <div className="box_setting">
          <form>
            <fieldset>
              <legend className="screen_out">광고 노출설정</legend>
              <ul className="list_setting_ad">
                {positionList.map((position, index) =>
                  <li className={checkActivated(position) ? 'selected_g' : ''} key={position}>
                    <div className="box_edit">
                      <strong className="tit_g">
                        {positionToName[position]}
                        {position === 'automatic' && checkActivated(position) &&
                        <span className="ico_blog ico_on"/>
                        }
                      </strong>
                      <dl>
                        <dt><span className="ico_blog ico_pc_type1">PC</span></dt>
                        <dd>{getPcType(position)}</dd>
                      </dl>
                      <dl>
                        <dt><span className="ico_blog ico_mobile_type1">모바일</span></dt>
                        <dd>{getMobileType(position)}</dd>
                      </dl>
                    </div>
                    <div className="check_blog">
                      <input type="checkbox" id={`inptCheck${index + 1}`}
                             className="inp_check" checked={checkActivated(position)}
                             onChange={(e) => handleClickToggle(position, e.target.checked)}
                      />
                      <label htmlFor={`inptCheck${index + 1}`}
                             className="ico_blog ico_checkbox_type1">선택 됨</label>
                    </div>
                    {checkActivated(position) &&
                    <a className="btn_post" onClick={() => handleClickEdit(position)}>수정</a>
                    }
                  </li>
                )}
              </ul>
            </fieldset>
          </form>
        </div>
      </>
      }
      {!changedAdSetting &&
      <>
        <DefaultBoxPreview/>
        <DefaultAdSettingBox/>
      </>
      }
      <div className="box_ad_setting">
        <TSubmitButtonForm
          type="submit"
          onClick={save}
          status={saveStatus}
          label={SaveStatusLabel}
        />
        <button type="button" className="btn_preview" onClick={showPreviewHandler}>미리보기
          <span className="ico_blog">새창으로 열기</span>
        </button>
      </div>
      {!changedAdSetting && !error &&
      <div className="date_loading">
        <div className="inner_g">
          <span className="ico_blog ico_loading">로딩중입니다.</span>
        </div>
      </div>
      }
      {error &&
      <div className="statistic_refresh info_none">
        <div className="inner_refresh">
          <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
          <a onClick={fetchAdSetting} className="link_none">다시 조회하기</a>
        </div>
      </div>
      }
      {editingPosition &&
      <AdEditDialog
        adSetting={changedAdSetting}
        position={editingPosition}
        handleClickCancel={handleClickPopupCancel}
        handleClickConfirm={handleClickPopupConfirm}
      />
      }
      {showPreview && <Preview
        showPreviewHandler={showPreviewHandler}
        settings={previewSettings}
      />}
      {activateInfo &&
      <RevenueDialog
        title={activateInfo.title}
        content={activateInfo.content}
        required={activateInfo.required}
        close={()=>setActivateInfo(null)}
        cancel={activateInfo.cancel}
        confirm={activateInfo.confirm}
      />
      }
    </div>
  )
};

export default AdSetting;
